import { render } from "./UserUpload.vue?vue&type=template&id=599d705e&scoped=true"
import script from "./UserUpload.vue?vue&type=script&lang=js"
export * from "./UserUpload.vue?vue&type=script&lang=js"

import "./UserUpload.vue?vue&type=style&index=0&id=599d705e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599d705e"]])

export default __exports__